import React, { useState, useEffect } from "react";
import SummaryApi from "../common";

// Import Swiper React components and styles
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const Reviews = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  // High-quality static reviews
  const staticReviews = [
    {
      review_id: "static-1",
      review_description: "Finally, a product that doesn't feel like plastic! The organic cotton is so gentle on my sensitive skin and provides amazing comfort all day long.",
      user_name: "Sarah Jenkins",
      product_title: "Verified Buyer",
      user_image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?q=80&w=150&h=150&auto=format&fit=crop"
    },
    {
      review_id: "static-2",
      review_description: "I highly recommend these to my patients. The pH-balanced materials are a game changer for women's health and daily hygiene.",
      user_name: "Dr. Ananya Rao",
      product_title: "Gynaecologist",
      user_image: "https://images.unsplash.com/photo-1594824476967-48c8b964273f?q=80&w=150&h=150&auto=format&fit=crop"
    },
    {
      review_id: "static-3",
      review_description: "The protection stays in place even during my most intense yoga sessions. Zero leaks and total confidence. Best subscription I've ever joined!",
      user_name: "Priya Sharma",
      product_title: "Fitness Instructor",
      user_image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=150&h=150&auto=format&fit=crop"
    }
  ];

  const fetchActiveReviews = async () => {
    try {
      setLoading(true);
      const response = await fetch(SummaryApi.getActiveReviews.url, {
        method: SummaryApi.getActiveReviews.method,
      });
      const result = await response.json();
      
      if (result.status && result.data) {
        // COMBINE: Dynamic data from API + Static data
        setReviews([...result.data, ...staticReviews]);
      } else {
        setReviews(staticReviews);
      }
    } catch (error) {
      console.error("Error fetching reviews, using static fallback:", error);
      setReviews(staticReviews);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActiveReviews();
  }, []);

  if (loading) return <div className="text-center p-10 text-pink-500 font-bold">Loading Testimonials...</div>;

  return (
    <div className="w-full py-16 bg-gradient-to-b from-white to-pink-50/30">
      <div className="max-w-7xl mx-auto px-4">
        {/* Header Section */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4 tracking-tight">
            What Our Customers Say
          </h2>
          <p className="text-xl text-gray-600">Testimonials from our happy community</p>
        </div>

        {/* SWIPER CAROUSEL */}
        <div className="w-full">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={30}
            slidesPerView={1}
            autoplay={{ delay: 4000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            breakpoints={{
              640: { slidesPerView: 1.5 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
            className="pb-16" // Space for dots
          >
            {reviews.map((review, index) => (
              <SwiperSlide key={review.review_id || index}>
                <div 
                  className="h-full min-h-[350px] p-8 rounded-[2.5rem] shadow-xl shadow-pink-100/50 border border-pink-100 bg-white hover:border-pink-300 transition-all duration-300 flex flex-col justify-between"
                >
                  <div>
                    <div className="flex text-pink-400 mb-4">
                      {[...Array(5)].map((_, i) => (
                        <span key={i} className="text-lg">★</span>
                      ))}
                    </div>
                    <p className="text-gray-700 leading-relaxed italic text-lg line-clamp-5">
                      "{review.review_description}"
                    </p>
                  </div>

                  <div className="mt-8 flex items-center gap-4">
                    <div className="w-14 h-14 rounded-full bg-pink-100 border-2 border-white shadow-sm flex items-center justify-center overflow-hidden flex-shrink-0">
                      <img 
                        src={review.user_image || `https://ui-avatars.com/api/?name=${review.user_name || 'User'}&background=FDF2F8&color=EC4899`} 
                        className="w-full h-full object-cover" 
                        alt={review.user_name} 
                      />
                    </div>
                    <div>
                      <h4 className="font-bold text-gray-800 block text-base md:text-lg truncate max-w-[150px]">
                        {review.user_name || "Verified Customer"}
                      </h4>
                      <span className="text-[10px] font-semibold text-pink-500 uppercase tracking-widest block">
                        {review.product_title || "Verified Purchase"}
                      </span>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      {/* Styles for Pink Pagination */}
      <style>{`
        .swiper-pagination-bullet-active {
          background: #db2777 !important; 
          width: 24px;
          border-radius: 4px;
        }
      `}</style>
    </div>
  );
};

export default Reviews;